import { memo } from "react";

import { TransitionLinkV2 } from "@/src/common/TransitionLinkV2";
import ImageLoader from "@Components/ImageLoader";
import { defaultToTrue, urlFormat } from "@Components/Modules/Helpers";
import type { BlogPostMobile } from "@Routes/BlogLinks";
import * as stylex from "@stylexjs/stylex";

import { genericStyles } from "../../styles/tokens.stylex";

import * as css from "./PostTile.module.css";

export interface IPostTile {
    image: string;
    imageAlt: string;
    title: string;
    description: string;
    id: number;
    slug: string;
    dayOfPost: string;
    monthOfPost: string;
    yearOfPost: string;
    urlTemplate: typeof BlogPostMobile;
}

export const PostTile = memo(
    (props: IPostTile) => (
        <div className={`${css.postTileComponent} ${stylex.props(styles.border).className}`}>
            <TransitionLinkV2
                variant="none"
                href={urlFormat(props.urlTemplate, { id: props.id, slug: props.slug }, false)}
                aria-label={props.title}
            >
                <div className={css.imageContainer}>
                    <ImageLoader alt={props.imageAlt} src={props.image} />
                </div>
                <div className={css.textContainer}>
                    <div className={css.date}>
                        {`${props.monthOfPost} ${props.dayOfPost}, ${props.yearOfPost}`}
                    </div>
                    <h4 className={css.title} dangerouslySetInnerHTML={{ __html: props.title }} />
                    <div className={css.slideElement}>
                        <div className={css.inner} dangerouslySetInnerHTML={{ __html: props.description }} />
                    </div>
                </div>
            </TransitionLinkV2>
        </div>
    ),
    defaultToTrue,
);

const styles = stylex.create({
    border: {
        borderRadius: genericStyles.borderRadiusS1,
    },
});
